import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { SubstancePreviousEvCodeEntity } from "../../../Data/MedicinalProductData/SubstancePreviousEvCodeEntity";
import { ApprovedSubstanceAutoUploadEntity } from "./ApprovedSubstanceAutoUploadEntity";
import { DevelopmentSubstanceAutoUploadEntity } from "./DevelopmentSubstanceAutoUploadEntity";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeSubstancePreviousEvCode extends BaseNode {

    useHist: boolean = false;
    cloningNode: boolean = false;
    items: any;
    constructor(injector: Injector, cloningNode: boolean, model: any, parent:any) {

        super(injector,
            new SubstancePreviousEvCodeEntity(injector, model),
            `${model.devevcode?model.devevcode.value:''}`);

        this.parent=parent;
        this.items = model;
        this.cloningNode = cloningNode;
        if (this.cloningNode) {
            return;
        }
                
        this.ioc!.get(Art57Section).generateNumColumValue(this);

        if (model.substance){
            if (model.substance.type == 1){
                this.children?.push(new DevelopmentSubstanceAutoUploadEntity(this.ioc!, `Development - ${model.substance.ev_Code} - ${model.substance.substancename}`, this, model.substance, this.useHist, true, false));
            } else if (model.substance.type == 2){
                this.children?.push(new ApprovedSubstanceAutoUploadEntity(this.ioc!, `Approved - ${model.substance.ev_Code} - ${model.substance.substancename}`, this, model.substance, this.useHist, true, false));
            }
        }

    }

    public getListItem(): any[] {
        return [this.data.model.devevcode.value];
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: TreeNodeSubstancePreviousEvCode = new TreeNodeSubstancePreviousEvCode(this.ioc!,true,  this.items, newParent);        
      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)
 
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }    
}